"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceIntermediary = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.InvoiceIntermediary = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    receipt_invoice: typebox_1.Type.String(),
    order_number: typebox_1.Type.String(),
    invoice_number: typebox_1.Type.String(),
    payment_link: typebox_1.Type.String(),
});
//# sourceMappingURL=invoice-intermediary.js.map